var PostBody = function() {
    require('fluidbox');
    $('.post-body img').each(function() {
        var $parent = $(this).parent();
        if ($parent.is('a') && $parent.children().length == 1 && $parent.attr('href').indexOf('static.fashionpost.jp') != -1) {
            $parent.fluidbox();
        }
    });

    if (!$('body').hasClass('smp')) {
        var $body = $('.post-body:last');

        var getMargin = function(target) {
            var $inner = $('.l-post-inner');
            var innerLeft = (($inner.outerWidth(true) - $inner.width()) / 2);
            var bodyLeft = $('.post-body').position().left + (($inner.outerWidth(true) - $inner.outerWidth()) / 2);
            var margin = innerLeft - bodyLeft;
            var width = $(target).outerWidth(true);
            if (margin > width) {
                margin = width
            }

            return margin;
        };

        $body.find('div.wp-caption.alignnone').each(function() {
            var $next = $(this).next();
            if ($next.find('img').length > 0 || $next.text().replace(/\s/g, '') == '' || $next.hasClass('p1')) {
                return true;
            }

            $(this).css('clear', 'both');
            $(this).css('margin-right', '20px');
            $(this).css('margin-left', getMargin(this));
            $(this).css('float', 'left');
        });

        $body.find('iframe.overflow').each(function() {
            $(this).css('clear', 'both');
            $(this).css('margin-right', '20px');
            $(this).css('margin-left', getMargin(this));
            $(this).css('float', 'left');
        });

        $body.find('p img.alignnone').each(function() {
            var $parent = $(this).parents('p');
            var $next = $parent.next();

            if ($next.find('img').length > 0 || $next.text().replace(/\s/g, '') == '' || $next.hasClass('p1')) {
                return true;
            }

            $(this).css('margin-left', getMargin(this))
            $parent.css('float', 'left');
        });
    }
};

module.exports = PostBody;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/PostBody.js
 **/